const API_URL = process.env.VUE_APP_API_URL
const getToken = () => localStorage.getItem('access-token')

export default {
  async getAnnouncementsAPI (page = 1, size = 10) {
    const response = await fetch(`${API_URL}/admin/announcements?page=${page}&size=${size}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: getToken() }
    })
    const resp = await response.json()
    if (!response.ok) return Promise.reject(new Error(resp.error))
    return resp
  },

  async getAnnouncementAPI (id) {
    const response = await fetch(`${API_URL}/admin/announcements/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: getToken() }
    })
    const resp = await response.json()
    if (!response.ok) return Promise.reject(new Error(resp.error))
    return resp
  },

  async createAnnouncementAPI (data) {
    const { image, ...fields } = data
    const formData = new FormData()
    if (image && image.file) formData.append('image', image.file)
    Object.entries(fields).forEach(([key, value]) => {
      if (value !== null && value !== undefined) formData.append(key, value)
    })
    const response = await fetch(`${API_URL}/admin/announcements`, {
      method: 'POST',
      headers: { Authorization: getToken() },
      body: formData
    })
    const resp = await response.json()
    if (!response.ok) return Promise.reject(new Error(resp.error))
    return resp
  },

  async updateAnnouncementAPI (id, data) {
    const { image, ...fields } = data
    const formData = new FormData()
    if (image && image.file) formData.append('image', image.file)
    Object.entries(fields).forEach(([key, value]) => {
      if (value !== null && value !== undefined) formData.append(key, value)
    })
    const response = await fetch(`${API_URL}/admin/announcements/${id}`, {
      method: 'PUT',
      headers: { Authorization: getToken() },
      body: formData
    })
    const resp = await response.json()
    if (!response.ok) return Promise.reject(new Error(resp.error))
    return resp
  },

  async toggleAnnouncementStatusAPI (id) {
    const response = await fetch(`${API_URL}/admin/announcements/${id}/status`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: getToken() }
    })
    const resp = await response.json()
    if (!response.ok) return Promise.reject(new Error(resp.error))
    return resp
  },

  async getAnnouncementStatsAPI (id) {
    const response = await fetch(`${API_URL}/admin/announcements/${id}/stats`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: getToken() }
    })
    const resp = await response.json()
    if (!response.ok) return Promise.reject(new Error(resp.error))
    return resp
  },

  async deleteAnnouncementAPI (id) {
    const response = await fetch(`${API_URL}/admin/announcements/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', Authorization: getToken() }
    })
    const resp = await response.json()
    if (!response.ok) return Promise.reject(new Error(resp.error))
    return resp
  }
}
